import { Action } from 'store/store';
import IndigoApiError from 'communication/IndigoApiError';
import { SymbolEventsResponse } from 'widgets/corpActions/api/SymbolEventsResponse';
import { AnyAction } from 'redux';

export enum CorpActionsActionType {
    CORP_ACTIONS_CLEAR_DATA = 'CORP_ACTIONS_CLEAR_DATA',
    CORP_ACTIONS_HANDLE_RESPONSE = 'CORP_ACTIONS_HANDLE_RESPONSE',
    CORP_ACTIONS_HANDLE_ERROR = 'CORP_ACTIONS_HANDLE_ERROR',
}

export interface CorpActionsDataPayload {
    requestKey: string;
}

export type CorpActionsClearDataAction = Action<
    CorpActionsActionType.CORP_ACTIONS_CLEAR_DATA,
    CorpActionsDataPayload
>;

export const createCorpActionsClearDataAction: (
    requestKey: string
) => CorpActionsClearDataAction = (requestKey) => ({
    type: CorpActionsActionType.CORP_ACTIONS_CLEAR_DATA,
    payload: { requestKey },
});

export interface CorpActionsHandleResponseActionPayload
    extends CorpActionsDataPayload {
    response: SymbolEventsResponse;
}

export type CorpActionsHandleResponseAction = Action<
    CorpActionsActionType.CORP_ACTIONS_HANDLE_RESPONSE,
    CorpActionsHandleResponseActionPayload
>;

export const createCorpActionsHandleResponseAction: (
    requestKey: string,
    response: SymbolEventsResponse
) => CorpActionsHandleResponseAction = (requestKey, response) => ({
    type: CorpActionsActionType.CORP_ACTIONS_HANDLE_RESPONSE,
    payload: { requestKey, response },
});

export function isCorpActionsHandleResponseAction(
    action: AnyAction
): action is CorpActionsHandleResponseAction {
    const a = action as CorpActionsHandleResponseAction;
    return a.type === CorpActionsActionType.CORP_ACTIONS_HANDLE_RESPONSE;
}

export interface CorpActionsHandleErrorActionPayload
    extends CorpActionsDataPayload {
    error: IndigoApiError;
}

export type CorpActionsHandleErrorAction = Action<
    CorpActionsActionType.CORP_ACTIONS_HANDLE_ERROR,
    CorpActionsHandleErrorActionPayload
>;

export function createHandleCorpActionsErrorAction(
    requestKey: string,
    error: IndigoApiError
): CorpActionsHandleErrorAction {
    return {
        type: CorpActionsActionType.CORP_ACTIONS_HANDLE_ERROR,
        payload: { requestKey, error },
    };
}

export type CorporateActionsAction =
    | CorpActionsClearDataAction
    | CorpActionsHandleResponseAction
    | CorpActionsHandleErrorAction;
